export default __webpack_public_path__ + "static/media/apple-icon-120x120.5e684aab.png";